// src/components/shipment/StatusBadge.jsx
import React from 'react';

const statusConfig = {
  'Pending Onboard': {
    pill: 'bg-amber-100 border-amber-400/60 text-amber-900 dark:bg-amber-500/15 dark:border-amber-400/35 dark:text-amber-300',
    dot:  'bg-amber-500',
  },
  'In Transit': {
    pill: 'bg-sky-100 border-sky-400/60 text-sky-900 dark:bg-sky-500/15 dark:border-sky-400/35 dark:text-sky-300',
    dot:  'bg-sky-500',
  },
  'Delivered': {
    pill: 'bg-emerald-100 border-emerald-400/60 text-emerald-900 dark:bg-emerald-500/15 dark:border-emerald-400/35 dark:text-emerald-300',
    dot:  'bg-emerald-500',
  },
  'Delayed': {
    pill: 'bg-red-100 border-red-400/60 text-red-900 dark:bg-red-500/15 dark:border-red-400/35 dark:text-red-300',
    dot:  'bg-red-500',
  },
  'Booked': {
    pill: 'bg-indigo-100 border-indigo-400/60 text-indigo-900 dark:bg-indigo-500/15 dark:border-indigo-400/35 dark:text-indigo-300',
    dot:  'bg-indigo-500',
  },
  'Active': {
    pill: 'bg-emerald-100 border-emerald-400/60 text-emerald-900 dark:bg-emerald-500/15 dark:border-emerald-400/35 dark:text-emerald-300',
    dot:  'bg-emerald-500',
  },
};

const StatusBadge = ({ status }) => {
  const cfg = statusConfig[status] ?? statusConfig['Pending Onboard'];

  return (
    <span
      className={`
        relative inline-flex items-center gap-1.5
        px-3 py-[5px] rounded-full
        text-[11.5px] font-semibold tracking-wide
        border overflow-hidden
        ${cfg.pill}
      `}
    >
      {/* glossy sheen layer */}
      <span
        className="pointer-events-none absolute inset-0 rounded-full"
        style={{
          background:
            'linear-gradient(135deg, rgba(255,255,255,0.22) 0%, rgba(255,255,255,0) 60%)',
        }}
      />
      <span className={`relative w-[7px] h-[7px] rounded-full shrink-0 ${cfg.dot}`} />
      <span className="relative">{status}</span>
    </span>
  );
};

export default StatusBadge;